import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import CEProductCustomizationPrice from './CEProductCustomizationPrice.jsx';

const mountProductCustomizationPrice = () => {
  const elements = document.querySelectorAll('.product-customization-price-react');
  if (!elements.length) {
    return;
  }

  elements.forEach((element) => {
    if (!element) return;

    const shouldSetReactMounted = element.getAttribute('data-enable-react-mounted') !== 'false';
    if (shouldSetReactMounted && element.dataset.reactMounted === 'true') return;

    const storeName = element.getAttribute('data-store-name') || 'shared';
    const language = element.getAttribute('data-language') || element.getAttribute('data-locale') || 'it';
    const showOnlyPrice = element.getAttribute('data-show-only-price') === 'true';
    const extraTextClassName = element.getAttribute('data-extra-text-class-name') || '';
    const extraPriceClassName = element.getAttribute('data-extra-price-class-name') || '';
    const extraCompareAtPriceClassName = element.getAttribute('data-extra-compare-at-price-class-name') || '';
    const currency = element.getAttribute('data-currency-code');
    const selectVariantPrice = element.getAttribute('data-select-variant-price');
    const pricePosition = element.getAttribute('data-price-position') || 'first';

    let root = element.__productCustomizationPriceRoot;
    if (!root) {
      root = createRoot(element);
      element.__productCustomizationPriceRoot = root;
    }

    root.render(
      <StrictMode>
        <CEProductCustomizationPrice
          storeName={storeName}
          language={language}
          locale={language}
          showOnlyPrice={showOnlyPrice}
          extraTextClassName={extraTextClassName}
          extraPriceClassName={extraPriceClassName}
          extraCompareAtPriceClassName={extraCompareAtPriceClassName}
          currencyCode={currency}
          selectVariantPrice={selectVariantPrice}
          pricePosition={pricePosition}
        />
      </StrictMode>,
    );

    if (shouldSetReactMounted) {
      element.dataset.reactMounted = 'true';
    }
  });
};

mountProductCustomizationPrice();

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (
      Array.from(mutation.addedNodes).some(
        (node) =>
          node instanceof HTMLElement &&
          (node.matches('.product-customization-price-react') ||
            node.querySelector('.product-customization-price-react')),
      )
    ) {
      mountProductCustomizationPrice();
      break;
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
